import useTranslation from './useTranslation';

const useCommonWords = () => {
  const c = useTranslation('CommonWords');
  return c;
};

export default useCommonWords;
